import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Clock } from "lucide-react";
import { residentApi } from "../lib/api";
import { money } from "../lib/format";

export default function PaymentResultPage() {
  const [params] = useSearchParams();
  const oid = params.get("oid");
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location.href = window.location.href;
    }
  }, []);

  useEffect(() => {
    if (!oid) return undefined;
    let n = 0;
    const tick = () => residentApi.get(`/resident/payment/status/${oid}`).then((r) => setStatus(r.data)).catch(() => setStatus({ status: "unknown" }));
    tick();
    const t = setInterval(() => {
      n += 1;
      if (n > 10) clearInterval(t);
      else tick();
    }, 3000);
    return () => clearInterval(t);
  }, [oid]);

  const s = status?.status || (params.get("durum") === "hata" ? "failed" : "pending");
  const ok = s === "success";
  const fail = ["failed", "token_failed"].includes(s) || params.get("durum") === "hata";

  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="payment-result">
      {ok ? <CheckCircle2 size={64} className="mx-auto text-[#1B4332]" /> : fail ? <XCircle size={64} className="mx-auto text-[#B4492F]" /> : <Clock size={64} className="mx-auto text-slate-400" />}
      <h1 className="font-display text-3xl font-bold mt-6 text-slate-800" data-testid="payment-result-title">
        {ok ? "Ödemeniz alındı" : fail ? "Ödeme tamamlanamadı" : "Ödemeniz onaylanıyor"}
      </h1>
      <p className="text-slate-500 mt-3">
        {ok ? `${money(status.debt_amount)} borcunuz hesabınıza işlendi. Teşekkür ederiz.` : fail ? "Kartınızdan çekim yapılmadı. Lütfen tekrar deneyin veya Havale/EFT kullanın." : "Bankadan onay bekleniyor, bu birkaç saniye sürebilir."}
      </p>
      <Link to="/odemeler" className="inline-block mt-8 px-6 py-3 rounded-full bg-[#1B4332] text-white font-bold" data-testid="payment-result-back">Ödemelerime dön</Link>
    </div>
  );
}
